import React, { FC } from "react";
import { Label, Radio, Input } from "@trussle/external-components";
import { trackEvent } from "../../../../../helpers/analytics";
import { ValueType } from "../data";
import "../styles.scss";

interface ILoanToValueFormProps {
    valueType: ValueType;
    setValueType: (valueType: ValueType) => void;
    propertyValue: string;
    setPropertyValue: (propertyValue: string) => void;
    knownValue: string;
    setKnownValue: (knownValue: string) => void;
    handleAnimation: () => void;
}

const LoanToValueForm: FC<ILoanToValueFormProps> = ({
  valueType, setValueType, propertyValue, setPropertyValue, knownValue, setKnownValue, handleAnimation,
}) => (
  <form>
    <div className="form-group">
      <Input
        betterV2
        variant="currency"
        classOverrides={{ inputContainer: "calculator-input" }}
        label="Property value"
        name="Property value"
        inputSize="large"
        value={propertyValue}
        data-testid="loan-to-value-calculator-propertyValue"
        onChange={(e) => {
          trackEvent("Property Value Changed", {
            module: "LTV Calculator",
            value: e.target.value,
            element_type: "Text field",
          });
          handleAnimation();
          setPropertyValue(e.target.value);
        }}
      />
    </div>
    <div className="form-group loan-to-value-calculator-radio-buttons">
      <Label title="I know my:" htmlFor="loan-to-value-calculator-value-type" className="calculator-label" />
      <Radio
        id="loan-to-value-calculator-value-type"
        variant="v2"
        data-testid="loan-to-value-calculator-valueType"
        options={[
          { code: ValueType.DEPOSIT_AMOUNT, description: "Deposit amount" },
          { code: ValueType.LOAN_AMOUNT, description: "Loan amount" },
          { code: ValueType.LTV_PERCENTAGE, description: "Loan to value" },
        ]}
        value={valueType}
        onChange={(e) => {
          trackEvent("Value Type Changed", {
            module: "LTV Calculator",
            value: e.target.value,
            element_type: "Radio",
          });
          setKnownValue("");
          setValueType(e.target.value as ValueType);
        }}
      />
    </div>
    <div className="form-group">
      {valueType === ValueType.DEPOSIT_AMOUNT ? (
        <Input
          betterV2
          variant="currency"
          classOverrides={{ inputContainer: "calculator-input" }}
          inputSize="large"
          name="Deposit amount"
          label="Deposit amount"
          data-testid="loan-to-value-calculator-valueType-deposit"
          onChange={(e) => {
            trackEvent("Known Value Changed", {
              module: "LTV Calculator",
              value: e.target.value,
              element_type: "Text field",
            });
            handleAnimation();
            setKnownValue(e.target.value);
          }}
          value={knownValue}
        />
      ) : null}
      {valueType === ValueType.LOAN_AMOUNT ? (
        <Input
          betterV2
          variant="currency"
          classOverrides={{ inputContainer: "calculator-input" }}
          name="Loan amount"
          label="Loan amount"
          inputSize="large"
          data-testid="loan-to-value-calculator-valueType-loan"
          onChange={(e) => {
            trackEvent("Known Value Changed", {
              module: "LTV Calculator",
              value: e.target.value,
              element_type: "Text field",
            });
            handleAnimation();
            setKnownValue(e.target.value);
          }}
          value={knownValue}
        />
      ) : null}
      {valueType === ValueType.LTV_PERCENTAGE
        ? (
          <Input
            betterV2
            variant="percentage"
            classOverrides={{ inputContainer: "calculator-input" }}
            inputSize="large"
            name="LTV"
            label="LTV"
            data-testid="loan-to-value-calculator-valueType-ltv"
            onChange={(e) => {
              trackEvent("Known Value Changed", {
                module: "LTV Calculator",
                value: e.target.value,
                element_type: "Text field",
              });
              handleAnimation();
              setKnownValue(e.target.value);
            }}
            value={knownValue}
          />
        )
        : null}
    </div>
  </form>
);

export default LoanToValueForm;
